<template>
  <div class="row h-100">
    <div class="col-12 h-100">
      <ContentItemDetailsModal
        modal-id="add-content-item-modal"
        :get-page="getPage"
        title="New Content Item"
        :structure-id="id"
        :structure-list="structureList"
      />
      <ContentItemDetailsModal
        modal-id="edit-content-item-modal"
        modal-type="edit"
        :get-page="getPage"
        title="Edit Content Item"
        :selected-item-id="selectedItemId"
        :structure-id="id"
        :structure-list="structureList"
      />
      <div v-if="loaded" class="poppins h-100 d-flex flex-column" style="padding-bottom: 20px">
        <div class="inputs-block overflow-hidden d-flex flex-column" v-if="id" style="margin-top: 20px">
          <div class="item-block">
            <div class="d-flex">
              <div class="header">{{ 'Content items' | i18n }}</div>
              <b-button
                v-if="isCommonAdmin"
                v-b-modal.add-content-item-modal
                variant="primary"
                size="sm"
                style="height: 33px; padding: 0px 10px"
              >
                <BIconPlus />{{ 'Add content item' | i18n }}
              </b-button>
            </div>
          </div>
          <div class="filter-block">
            <SearchInput :searchChange="searchChange" />
          </div>
          <Table
            :update="getPage"
            :columns="columns"
            :rows="rows"
            :filter="filter"
            :updateFilter="updateFilter"
            :loadingInstance="loadingInstance"
            :setLoadingInstance="setLoadingInstance"
            class="overflow-auto pr-1"
            tableName="dynamicDataContentDetailsTable"
          />
        </div>
      </div>
      <Loader v-else />
    </div>
  </div>
</template>
<script>
import { BIconPlus } from 'bootstrap-vue';

import Input from '../../common/input';
import { NotificationMixin, DeleteRowMixin, AuthMixin } from '../../../../mixins';
import Loader from '../../common/loader';
import Table from '../../common/table';
import SearchInput from '../../common/search-input';
import api from '../../../api';
import { DYNAMIC_DATA_TYPES } from '../../../../../../../constants';
import ContentItemDetailsModal from './content-item-details-modal';

let inputInterval = null;

export default {
  title: 'Dynamic data content',
  components: { Input, Loader, Table, SearchInput, BIconPlus, ContentItemDetailsModal },
  mixins: [NotificationMixin, DeleteRowMixin, AuthMixin],
  data() {
    return {
      loaded: false,
      name: '',
      id: '',
      selectedItemId: '',
      filter: {
        page: 1,
        limit: 20,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        searchQuery: '',
      },
      loadingInstance: null,
      typeOptions: Object.values(DYNAMIC_DATA_TYPES).map((value) => ({ value, text: value })),
      structure: [],
      structureList: [],
      columns: [],
      rows: [],
    };
  },
  async created() {
    this.id = this.$route.params.id;
    if (this.id) {
      const data = await api.dynamicData.getById(this.id);

      this.name = data.name;
      this.structure = Object.keys(data.structure);

      const dynamicColumns = this.structure.map((name) => ({
        field: name,
        title: name.charAt(0).toUpperCase() + name.slice(1),
        key: name,
        sortBy: '',
        align: 'left',
        renderBodyCell: ({ row }, h) => {
          if (data.structure[name] === DYNAMIC_DATA_TYPES.BOOLEAN) {
            return row[name].toString();
          }
          return row[name];
        }
      }));

      this.columns = [
        ...dynamicColumns,
        {
          field: 'actions',
          title: '',
          key: 'actions',
          width: 90,
          renderBodyCell: ({ row }, h) => {
            return (
              <div class="d-flex">
                {this.isCommonAdmin && (
                  <div class="copy-button" on-click={() => this.editContentItem(row)}>
                    {this.$translate('edit')}
                  </div>
                )}
                {this.isCommonAdmin && (
                  <div class="download-button delete-button" on-click={() => this.deleteContentItem(row)}>
                    {this.$translate('delete')}
                  </div>
                )}
              </div>
            );
          },
        },
      ];

      Object.keys(data.structure).forEach((value) => {
        this.structureList.push({ value, type: data.structure[value] });
      });
    }
    this.loaded = true;
  },
  methods: {
    async editContentItem(item) {
      this.selectedItemId = item.id;
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'edit-content-item-modal');
      }, 100);
    },
    async deleteContentItem(item) {
      await this.deleteSelectedRows(null, async () => {
        try {
          await api.dynamicData.removeContentItem(item.id);
          await this.getPage();
          this.showNotification({ type: 'success', message: this.$translate('success') });
        } catch (err) {
          this.showNotification({ type: 'error', message: err.message });
        }
      });
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        if (!this.id) {
          return;
        }
        this.startLoading();
        const { page, limit, sortBy, sortOrder, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        const response = await api.dynamicData.getContentItemsByStructureId(this.id, ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();
        this.rows = response.data.map(({ data, id }) => ({ ...data, id }));
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #add-team .modal-dialog {
  max-width: 700px !important;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.header {
  color: #5f5f5f !important;
  font-size: 1.6rem !important;
  font-weight: 400;
  text-transform: uppercase;
  margin-right: 20px;
}

.item-text {
  color: #5f5f5f !important;
  font-size: 1.2rem !important;
  font-weight: 400;
  margin-left: 20px;
  margin-top: 10px;
}

.header-block {
  width: 100%;
  display: flex;
  align-items: center;
}

.item-block {
  display: flex;
  margin-bottom: 30px;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
  cursor: pointer;
}

::v-deep .delete-button {
  background: rgb(219, 71, 79);
  color: white;
  border: 2px solid #db474f;
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  cursor: pointer;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 30px;
}
</style>
